interface TaggableEntity {
  tags: string[];
}

/**
 * Removes entities not containing all specified tags
 */
export function filterByTags<T extends TaggableEntity>(entities: T[], tags: string[]): T[] {
  return entities.filter((entity) => tags.every((tag) => entity.tags.includes(tag)));
}

/**
 * Sorts by tag priority
 *
 * Example:
 *
 * `sortByTags(groups, { "group-comp": 100, "group-kdict": 300} ), 200)`
 *
 * Result:
 *
 * 1. Company dictionaries (group-comp)
 * 2. Language groups (other)
 * 3. K-Dictionaries (group-kdict)
 */
export function sortByTags<T extends TaggableEntity>(
  entities: T[],
  tagPriority: Record<string, number>,
  defaultPriority = 0
): T[] {
  return [...entities].sort((entityA, entityB) => {
    const priorityA = Object.entries(tagPriority).reduceRight(
      (score, [tag, priority]) => (entityA.tags.includes(tag) ? priority : score),
      defaultPriority
    );
    const priorityB = Object.entries(tagPriority).reduceRight(
      (score, [tag, priority]) => (entityB.tags.includes(tag) ? priority : score),
      defaultPriority
    );
    return priorityA - priorityB;
  });
}
